module.exports = __webpack_public_path__ + "img/i6.ad9f3072.png";